/* Native shuffle: four-second start-to-start cadence, with accessible pause. */
(() => {
  const root = document.querySelector('.hero-memory');
  if (!root) return;
  const stack = root.querySelector('.polaroid-stack');
  const surface = root.querySelector('.stack-touch');
  const count = root.querySelector('.stack-count');
  const status = root.querySelector('.stack-status');
  const playback = root.querySelector('.stack-playback');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let order = [...root.querySelectorAll('.polaroid-card')];
  const transforms = [
    'translate(0px, 0px) rotate(3deg)',
    'translate(-9px, 3px) rotate(-5deg)',
    'translate(10px, 7px) rotate(7deg)',
    'translate(1px, 13px) rotate(-2deg)',
    'translate(-5px, 17px) rotate(2deg)'
  ];
  const firstImage = order[0].querySelector('img');
  const loadDeferredImages = () => order.forEach(card => {
    const image = card.querySelector('img');
    if (!image.dataset.src) return;
    image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    delete image.dataset.srcset;
    delete image.dataset.src;
  });
  if (firstImage.complete) loadDeferredImages();
  else firstImage.addEventListener('load', loadDeferredImages, {once:true});
  setTimeout(loadDeferredImages, 800);
  let announceTurn = true;
  let timer = null, paused = false, hovered = false, focused = false;
  let visible = typeof IntersectionObserver !== 'function';
  const stopTimer = () => { clearTimeout(timer); timer = null; };
  const mayPlay = () => !paused && !hovered && !focused && visible && !document.hidden && !reduce.matches;
  const schedule = () => {
    stopTimer();
    if (mayPlay()) timer = setTimeout(() => {
      timer = null;
      if (!mayPlay()) return;
      // Schedule from transition START, never from its 720 ms completion.
      schedule();
      shuffle(1, true);
    }, 4000);
  };
  let animations = [], busy = false, turn = 0, pointer = null, suppressClick = false;
  const settle = (announce = true) => {
    order.forEach((card, slot) => {
      card.dataset.slot = String(slot);
      card.setAttribute('aria-hidden', String(slot !== 0));
      card.style.transform = transforms[slot];
      card.style.zIndex = String(order.length - slot);
    });
    const index = String(Number(order[0].dataset.photo) + 1).padStart(2, '0');
    count.textContent = `${index} / ${String(order.length).padStart(2, '0')}`;
    if (announce) status.textContent = `Foto ${Number(index)} de ${order.length}. ${order[0].querySelector('img').alt}`;
    busy = false;
    root.removeAttribute('data-shuffling');
  };
  const finish = () => {
    turn++;
    animations.forEach(animation => animation.cancel());
    animations = [];
    settle(announceTurn);
  };
  const animate = (element, keyframes, duration) => {
    const animation = element.animate(keyframes, {duration, easing:'cubic-bezier(.22,.68,.16,1)', fill:'forwards'});
    animations.push(animation);
    return animation.finished.catch(() => {});
  };
  async function shuffle(direction = 1, automatic = false) {
    if (busy) return;
    loadDeferredImages();
    const nextImage = (direction > 0 ? order[1] : order[order.length - 1]).querySelector('img');
    if (!nextImage.complete || !nextImage.naturalWidth) {
      if (automatic) return;
      busy = true;
      try { await nextImage.decode(); } catch (_) { busy = false; return; }
      busy = false;
    }
    announceTurn = !automatic;
    if (!automatic) schedule();
    const oldOrder = [...order];
    const moving = direction > 0 ? order[0] : order[order.length - 1];
    order = direction > 0 ? [...order.slice(1), order[0]] : [moving, ...order.slice(0, -1)];
    if (reduce.matches || typeof moving.animate !== 'function') { settle(announceTurn); return; }
    busy = true;
    root.setAttribute('data-shuffling', '');
    const thisTurn = ++turn;
    const box = stack.getBoundingClientRect();
    // Keep the outer corner inside the viewport, including narrow phones.
    const available = document.documentElement.clientWidth - box.right - 18;
    let angle = 9;
    const rightExtension = degrees => {
      const radians = degrees * Math.PI / 180;
      return -.5 * box.width + 1.015 * (.5 * box.width * Math.cos(radians) + .8 * box.height * Math.sin(radians));
    };
    while (angle > 4 && rightExtension(angle) + 10 > available) angle--;
    const travel = Math.max(0, Math.min(box.width * .25, available - rightExtension(angle)));
    const lifted = `translate(${travel}px, -${Math.min(18, box.width * .05)}px) rotate(${angle}deg) scale(1.015)`;
    moving.style.zIndex = direction > 0 ? String(order.length + 1) : '0';
    const start = transforms[oldOrder.indexOf(moving)];
    await animate(moving, [{transform:start}, {transform:lifted}], 310);
    if (thisTurn !== turn) return;
    moving.style.zIndex = direction > 0 ? '0' : String(order.length + 1);
    const returns = order.map((card, slot) => {
      if (card !== moving) card.style.zIndex = String(order.length - slot);
      return animate(card, [{transform:card === moving ? lifted : transforms[oldOrder.indexOf(card)]}, {transform:transforms[slot]}], 410);
    });
    await Promise.all(returns);
    if (thisTurn !== turn) return;
    finish();
  }
  root.querySelector('.stack-prev').addEventListener('click', () => shuffle(-1));
  root.querySelector('.stack-next').addEventListener('click', () => shuffle(1));
  surface.addEventListener('click', () => {
    if (suppressClick) { suppressClick = false; return; }
    shuffle(1);
  });
  root.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      shuffle(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  surface.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.button !== 0) return;
    suppressClick = false;
    pointer = {x:event.clientX, y:event.clientY, id:event.pointerId};
  });
  surface.addEventListener('pointerup', event => {
    if (!pointer || pointer.id !== event.pointerId) return;
    const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
    pointer = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      suppressClick = true;
      shuffle(dx < 0 ? 1 : -1);
    }
  });
  surface.addEventListener('pointercancel', () => { pointer = null; });
  surface.addEventListener('pointerleave', () => { pointer = null; });
  window.addEventListener('resize', () => { if (busy) finish(); });
  const refresh = () => {
    if (!mayPlay() && busy) finish();
    playback.disabled = reduce.matches;
    const playbackLabel = reduce.matches ? 'Galería automática desactivada por movimiento reducido' : paused ? 'Reproducir galería automática' : 'Pausar galería automática';
    playback.setAttribute('aria-label', playbackLabel);
    playback.setAttribute('title', playbackLabel);
    playback.setAttribute('aria-pressed', String(paused || reduce.matches));
    schedule();
  };
  playback.addEventListener('click', () => { paused = !paused; refresh(); });
  root.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { hovered = true; refresh(); } });
  root.addEventListener('pointerleave', () => { hovered = false; refresh(); });
  root.addEventListener('focusin', () => { focused = true; refresh(); });
  root.addEventListener('focusout', event => { focused = root.contains(event.relatedTarget); refresh(); });
  document.addEventListener('visibilitychange', refresh);
  reduce.addEventListener('change', refresh);
  if (typeof IntersectionObserver === 'function') {
    const observer = new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
      refresh();
    }, {threshold: [0, .25]});
    observer.observe(root);
  }
  settle(false);
  refresh();
})();
